import * as React from "react";

import { useTable } from "@/react/components/table";
import TableComponent from "@/react/components/table/TableComponent";
import { filterTableMutations } from "@/react/components/table/filterTableMutations";

import schema from "./schema";
import columnDefinition from "./columnDefinition";

const KEY_COLUMN_ID = schema.fields.jobId.spec.key;
const COLUMN_DEFINITION = columnDefinition();

const JobInventoryTable = ({ data, isFetching, refetch, onJobSelected }) => {
  const { table, filters, state, mutations } = useTable(
    data,
    COLUMN_DEFINITION,
    schema,
    KEY_COLUMN_ID
  );
  const filteredMutations = React.useMemo(
    () => filterTableMutations(mutations),
    [mutations]
  );
  const onRowClick = React.useCallback(
    (row) => {
      onJobSelected(row?.getValue(KEY_COLUMN_ID));
    },
    [onJobSelected]
  );

  return (
    <TableComponent
      title="Inbound Phone Queues"
      schema={schema}
      isLoading={isFetching}
      onRefresh={refetch}
      table={table}
      filters={filters}
      mutations={filteredMutations}
      onSave={() => null}
      onCancel={() => null}
      isDirty={false}
      onRowClick={onRowClick}
      state={state}
    />
  );
};

export default JobInventoryTable;
